// extracted by mini-css-extract-plugin
module.exports = {"title":"SocialMedia_title__3z7YS","shareImage":"SocialMedia_shareImage__17rv7"};